import { promiseAction } from 'utils/store';

export const COMPLAINTS_ACTION_TYPES = {
  LOAD_COMPLAINTS: 'complaints/LOAD_COMPLAINTS',
  RESOLVE_COMPLAINT: 'complaints/RESOLVE_COMPLAINT',
};

export const loadComplaints = promiseAction(COMPLAINTS_ACTION_TYPES.LOAD_COMPLAINTS)
export const resolveComplaint = promiseAction(COMPLAINTS_ACTION_TYPES.RESOLVE_COMPLAINT)
